import React from 'react'

const Home = () => {
    return (
        <div>
            <div class="card card-horizontal">
                <div class="card-body">
                    <div class="card-horizontal-left">
                        <div class="card-category">
                            <a href="category.html">Food &amp; Drink</a> </div>
                        <h3 class="card-title"><a href="single-post.html">Best and Worst Summer Foods</a></h3>
                        <div class="card-excerpt">
                            <p>Admodum comprehenderit id non cillum anim de appellat, ubi tamen singulis sempiternum, occaecat sunt appellat appellat ex varias an in quem laborum an si ita quid multos irure do excepteur culpa quamquam. Nam aliqua iudicem aliquip o sunt cupidatat...</p>
                        </div>
                        <div class="card-horizontal-meta">
                            <div class="eskimo-author-meta">
                                By <a class="author-meta" href="author.html">Egemenerd</a>
                            </div>
                            <div class="eskimo-date-meta">
                                <a href="single-post.html">May 22, 2018</a>
                            </div>
                            <div class="eskimo-reading-meta">3 min read</div>
                        </div>
                    </div>
                    <div class="card-horizontal-right" data-img="../../../eskimo.egemenerd.com/wp-content/uploads/2018/05/blog18-1024x682.html">
                        <a class="card-featured-img" href="single-post.html"></a>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Home